import {createSlice} from "@reduxjs/toolkit";

const initialPendingActionsState = {
  isLoading: true,
  data: [],
  document: null,
  notification: null
};

export const pendingActionsSlice = createSlice({
  name: "pendingActions",
  initialState: initialPendingActionsState,
  reducers: {
    // PendingAction Responses
    pendingActionNotification: (state, action) => {
      state.notification = action.payload.notification;
    },

    // fetchPendingActions
    pendingActionsFetched: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
    },
    
    // confirmPendingAction
    pendingActionConfirmed: (state, action) => {
      state.notification = {type: "success", message: "Action Confirmed Successful"};
      state.data = state.data.filter(el => el.id !== action.payload.id);
    },
    
    // deletePendingAction
    pendingActionDeleted: (state, action) => {
      state.notification = {type: "success", message: "Action Deleted Successful"};
      state.data = state.data.filter(el => el.id !== action.payload.id);
    },

    // fetch Document
    documentFetched: (state, action) => {
      state.isLoading = false;
      state.document = action.payload.document;
    }
  }
});
